import React from "react";
import "@/App.css";
import { LanguageProvider, useLanguage } from "@/context/LanguageContext";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import IntroSection from "@/components/IntroSection";
import PrinciplesSection from "@/components/PrinciplesSection";
import DefinitionsSection from "@/components/DefinitionsSection";
import ReportingSection from "@/components/ReportingSection";
import AIAgentSection from "@/components/AIAgentSection";
import SafeguardingOfficerSection from "@/components/SafeguardingOfficerSection";
import RiskAreasSection from "@/components/RiskAreasSection";
import RecruitmentSection from "@/components/RecruitmentSection";
import ConductSection from "@/components/ConductSection";
import AdditionalSections from "@/components/AdditionalSections";
import DownloadsSection from "@/components/DownloadsSection";
import Footer from "@/components/Footer";
import AIChatWidget from "@/components/AIChatWidget";

const AppContent = () => {
  const { dir } = useLanguage();
  return (
    <div className="App" dir={dir}>
      <Header />
      <HeroSection />
      <IntroSection />
      <PrinciplesSection />
      <DefinitionsSection />
      <ReportingSection />
      <AIAgentSection />
      <SafeguardingOfficerSection />
      <RiskAreasSection />
      <RecruitmentSection />
      <ConductSection />
      <AdditionalSections />
      <DownloadsSection />
      <Footer />
      <AIChatWidget />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
